import { z } from "zod/v4";

import { ShippingProfileDtoSchema } from "../../../dtos/shipping-profiles";

export const GetShippingProfilesResponseBodySchema =
  ShippingProfileDtoSchema.array();

export type GetShippingProfilesResponseBodyType = z.infer<
  typeof GetShippingProfilesResponseBodySchema
>;

export const GetShippingProfilesRequestPathParamsSchema = z.object({
  experienceId: z.uuid(),
});
export type GetShippingProfilesRequestPathParamsType = z.infer<
  typeof GetShippingProfilesRequestPathParamsSchema
>;
